<template>
    <div>
        <card title="Maestro de Items" icon="fas fa-list">
            <div class="row">
                <div class="col-4">
                    <button @click="update()" class="btn btn-success" type="button">Sincronizar
                        <i class="fa fa-sync"></i>
                    </button>
                    <button @click="showMassiveActivatedMasterItemsModal()" class="btn btn-success ml-2" type="button">Activación Masiva
                        <i class="fa fa-check-circle"></i>
                    </button>
                </div>
                <div class="col-8">
                    <search-options :placeholder="'Buscar por Sku, Descripción o Sub Grupo...'" :withSeeDeactivated="true" :links="links" @index="index"
                        @reset="reset"></search-options>
                </div>
            </div>
            <div class="table-responsive">
                <manage-table :hover="true" :headers="[
                    'SKU',
                    'Descripción',
                    'Tipo Clase',
                    'Tamaño',
                    'Familia',
                    'Material',
                    'Temporada',
                    'Color',
                    'SubRubro',
                    'Sub Grupo',
                    'Grupo',
                    'Stock',
                    'Activo'
                ]">
                    <tr v-for="m in masterItems" :key="m.id">
                        <td style="width: 200px;">
                            <div class="row">
                                <div class="col-md-8">
                                    {{ m.c_sku }}
                                </div>
                                <div class="col-md-4" style="text-align: left;">
                                    <span v-if="(m.c_subgroup === 'ZVI2' || m.c_subgroup === 'ZMGB') && m.withActiveFormula === 0" class="badge badge-warning rounded-pill p-2" title="Item sin Fórmula Vigente">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </span>
                                    <a title="Item con Fórmula Vigente - Clic para ver" target="_blank" v-if="(m.c_subgroup === 'ZVI2' || m.c_subgroup === 'ZMGB') && m.withActiveFormula > 0" class="btn btn-sm btn-success" :href="'/formulas?search='+m.c_sku">
                                        <i class="fa fa-fas fa-flask"></i>
                                    </a>
                                </div>
                            </div>
                        </td>
                        <td>{{ m.d_sku }}</td>
                        <td>{{ m.d_class_tye }}</td>
                        <td>{{ m.d_size }}</td>
                        <td>{{ m.d_family }}</td>
                        <td>{{ m.d_material }}</td>
                        <td>{{ m.d_season }}</td>
                        <td>{{ m.d_color }}</td>
                        <td>{{ m.d_sub_heading }}</td>
                        <td>{{ m.d_subgroup }}</td>
                        <td>{{ m.d_group }}</td>
                        <td style="width: 300px;">
                            <div class="d-flex flex-wrap gap-2">
                                <div v-for="stock in m.stocks" :key="stock" class="badge badge-success p-2 m-1" style="font-size: 16px; display: inline-block; white-space: nowrap;">
                                    <div>
                                        <strong>{{ stock.stock }}</strong>
                                    </div>
                                    <div style="font-size: 10px; background-color: white; color: black; border-radius: 0.25rem; padding: 2px 6px; display: inline-block;">
                                        <span v-if="stock.harvest">Cosecha: {{ stock.harvest }}</span>
                                        <span v-else>Sin Cosecha</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <b-form-checkbox v-model="m.active" @change="changeActive(m.active, m.c_sku)" name="check-button" switch></b-form-checkbox>
                        </td>
                    </tr>
                </manage-table>
            </div>
            <paginator class="mt-4" :links="links"></paginator>
        </card>
        <modal id="massiveActivatedMasterItemsModal" :title="'Activación Masiva de Items'" @modalClose="index">
            <massive-activated-masteritems @updateDone="hideMassiveActivatedMasterItemsModal"></massive-activated-masteritems>
        </modal>
    </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import $ from "jquery";
import { getUrlQuery } from "../../helper/queryHelper";
export default {
    components: {
        Card,
    },
    data() {
        return {
            masterItems: [],
            Post,
            Delete,
            apiUrl: this.$store.getters.apiUrl,
            Get,
            Put,
            links: {},
            getUrlQuery,
        };
    },
    watch: {
        urlQuery: function () {
            this.index();
        },
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.$store.commit("setLoading", true);
            this.Get(this.apiUrl + "v1/masterItems?" + this.urlQuery, (res) => {
                this.masterItems = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });
        },
        update() {
            this.$swal({
                title: "¿Desea Actualizar los Materiales y Fórmulas desde PRO SAP?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoading", true);
                    this.Post(this.apiUrl + "v1/SyncWsMasterItems/", () => {
                        this.$store.commit("setLoading", false);
                        this.$swal.fire(
                            "Sincronización Finalizada",
                            "Los Materiales han sido actualizados correctamente desde PRO SAP."
                        );
                    });
                }
            });
        },
        changeActive(active, sku) {
            active = !active
            var activeText = 'Activar'
            var activedText = 'Activado'
            if (!active){
                activeText = 'Desactivar'
                activedText = 'Desactivado'
            }

            let data = {
                'active': active,
                'sku': sku
            }
        
            this.$swal({
                title: `¿Desea ${activeText} ${sku}?`,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoading", true);
                    this.Put(this.apiUrl + "v1/MasterItems/ActivateDeactivate", data, () => {
                        this.$store.commit("setLoading", false);
                        this.$swal.fire(
                            "Actualización Finalizada",
                            `${sku} ha sido ${activedText}`
                        );
                    });
                }
            });
        },
        reset() {
            this.links = {};
            this.index();
        },
        showMassiveActivatedMasterItemsModal(){
            $('#massiveActivatedMasterItemsModal').modal('show');
        }
        ,
        hideMassiveActivatedMasterItemsModal() {
            $('#massiveActivatedMasterItemsModal').modal('hide');
            this.index();
        },
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery();
        },
    },
};
</script>
